import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "selector", "submitter", "loadMore" ]

  connect() {
    let initialTimeElement = $(this.selectorTarget).find("input:checked");
    this.timeElement = initialTimeElement;
    this.daysToShow = 7; // Show first 7 days

    console.log("Installation Calendar")
  }

  selectInstallationTime(event) {
    let timeElement = $(event.target);
    this.timeElement = timeElement
  }

  get timeElement() {
    return this.data.get('selectedTime')
  }

  set timeElement(timeElement) {
    let selectedTime = timeElement.attr('data-time');
    this.data.set('selectedTime', selectedTime)

    $('.card.time-slot-selected').removeClass('time-slot-selected')
    timeElement.closest('.card').addClass('time-slot-selected')

    if (selectedTime) {
      $(this.submitterTarget).removeAttr("disabled")
    } else {
      $(this.submitterTarget).attr("disabled", true)
    }
  }

  selectInstallationTime(event) {
    let timeElement = $(event.currentTarget).closest("input");

    this.timeElement = timeElement;

    // Auto-scroll into view for better mobile UX
    if (window.innerWidth < 768) {
      event.currentTarget.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  get timeElement() {
    return this.data.get("selectedTime");
  }

  set timeElement(timeElement) {
    let selectedTime = timeElement.attr("data-time");
    this.data.set("selectedTime", selectedTime);

    $(".card.time-slot-selected").removeClass("time-slot-selected");
    timeElement.closest(".card").addClass("time-slot-selected");

    if (selectedTime) {
      $(this.submitterTarget).removeAttr("disabled");
    } else {
      $(this.submitterTarget).attr("disabled", true);
    }

  }

  loadMoreSlots(e) {

    e.preventDefault();

    let hiddenDays = $(".more-slots.d-none").slice(0, this.daysToShow);

    hiddenDays.removeClass("d-none");

    // If there are no more hidden slots, remove the button
    if ($(".more-slots.d-none").length === 0) {
      $(this.loadMoreTarget).remove();
    }
  }

}
